import React from 'react'
import { Box, CssBaseline, Paper, Typography } from '@mui/material'
import ROUTES from '../../routesConfig'
import PageBackRow from '../UI/PageBackRow'
import {
  contentColumnMaxWidthSx,
  contentColumnShellSx
} from '../UI/contentColumn'

const EventOverPage = ({ anearEvent, customMessage, effectiveState }) => {
  const hasEvent = !!anearEvent
  const iconUrl = hasEvent && anearEvent.zone?.app?.iconUrl
  const shortName = hasEvent && anearEvent.zone?.app?.shortName
  const displayState = effectiveState || anearEvent?.state
  const defaultMessage = hasEvent
    ? `Sorry, the event '${anearEvent.name}' is ${displayState}.`
    : 'Sorry, this event is no longer available.'

  return (
    <Box
      // px keeps the gutters phones have always had; from sm up the column cap sets the width.
      sx={{ ...contentColumnShellSx, px: 2 }}
      data-anear-content-column=""
    >
      <Box sx={contentColumnMaxWidthSx}>
        <CssBaseline />
        <Paper
          sx={{
            mt: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          pt: 2,
          px: 3,
          pb: 3
        }}
      >
        <PageBackRow to={ROUTES.APPS} label="Back to Apps" sx={{ mb: 1.5 }} />
        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
            {iconUrl && (
              <img
                style={{
                  height: '90px',
                  float: 'left',
                  marginRight: '16px'
                }}
                src={iconUrl}
                alt={shortName || 'Event'}
              />
            )}
            <Typography variant="h6">
              {customMessage || defaultMessage}
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Box>
  )
}

export default EventOverPage
